<mat-expansion-panel>
  <mat-expansion-panel-header>
    Filtra
  </mat-expansion-panel-header>
  <form [formGroup]="filtersForm" novalidate>

    <!-- Aggiunta del filtro per stato attivo/disattivo -->
    <div class="u-flex-full">
      <mat-form-field class="u-full-width" formControlName="onlyCurrentTenant">
        <mat-label>Attivo</mat-label>
        <mat-select formControlName="active">
          <mat-option [value]="null">Tutti</mat-option>
          <mat-option [value]="1">Attivo</mat-option>
          <mat-option [value]="0">Inattivo</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="u-flex-full" style="justify-content: flex-end;">
      <button mat-raised-button [disabled]="filtersForm.pristine"
      (click)="applyFilters()" color="primary">Filtra</button>
      <button mat-icon-button *ngIf="!filtersForm.pristine" (click)="resetFilters()" matTooltip="Reset">
        <mat-icon>replay</mat-icon>
      </button>
    </div>
  </form>
</mat-expansion-panel>
